/*!
  Brava, by Koding Themes
  recomendations.js
  https://kodingthemes.com
*/

(function() {
  var sliderInstances = {};

  document.addEventListener("DOMContentLoaded", function() {
    dynamicRecommendationsFunction(null);
  });
  document.addEventListener("shopify:section:load", function(e) {
    dynamicRecommendationsFunction(e.target);
  });

  function dynamicRecommendationsFunction(target) {
    var recommendedSections = document.querySelectorAll('.dynamic-recommendation-section');
    recommendedSections.forEach(function(recommendedSection) {
      if (target != null) {
        var targetSection = target.querySelector('.dynamic-recommendation-section');
        if (targetSection == recommendedSection) {
          sliderRecommendedLoop(recommendedSection);
        }
      } else {
        sliderRecommendedLoop(recommendedSection);
      }
    });
  }

  function sliderRecommendedLoop(recommendedSection) {
    var productRecomendationBody = recommendedSection.querySelector('.featured-related.grid-container-wrapper');
    if (productRecomendationBody == null) return;

    var sectionId = productRecomendationBody.dataset.sectionid;
    var url = recommendedSection.dataset.url;
    var sliderSelector = productRecomendationBody;

    var getProducts = async function() {
      var recommendURL = url.trim();
      var response = await fetch(recommendURL);
      var products = await response.json();
      return products;
    };

    getProducts()
      .then(function(data) {
        var products = data.products;
        if (products.length > 0) {
          products.forEach(function(product, index) {
            var product_handle = product.handle;
            var xhttp = new XMLHttpRequest();
            xhttp.onload = function() {
              var productRow = this.response;
              sliderSelector.insertAdjacentHTML('afterbegin', productRow);
              if (products.length == index + 1) {
                var myInterval = setInterval(function() {
                  var productsList = sliderSelector.querySelectorAll('.rec-products');
                  if (productsList.length == products.length) {
                    setTimeout(function() {
                      recommendedSection.classList.remove('recommendations-placeholder-active');
                    }, 500);
                    recommendedSection.classList.remove('d-none');
                    sliderRecommendedProducts(sectionId, sliderSelector);
                    clearInterval(myInterval);
                    var eventRecommendation = new CustomEvent('shopify-recommendation:init-product-grid', {
                      detail: { recommendations: products }
                    });
                    document.dispatchEvent(eventRecommendation);

                    // add image aspect ratio class
                    var imageRatio = recommendedSection.dataset.imageratio;
                    var images = productRecomendationBody.querySelectorAll('img');
                    if (images.length > 0) {
                      images.forEach(function(image) {
                        image.classList.add(imageRatio);
                      });
                    }
                  }
                }, 1);
              }
            };
            xhttp.open("GET", '/products/' + product_handle + '?view=recommended-product');
            xhttp.send();
          });
        }
        if (products.length < 3) {
          sliderSelector.classList.add('w-100');
        }
        if (products.length == 0) {
          recommendedSection.classList.add('d-none');
        }
      })
      .catch(function() {});
  }

  function sliderRecommendedProducts(sectionId, productRecomendationBody) {
    if (sliderInstances[sectionId]) {
      sliderInstances[sectionId].destroy();
      sliderInstances[sectionId] = null;
    }

    sliderInstances[sectionId] = tns({
      container: productRecomendationBody,
      items: 1,
      slideBy: 1,
      nav: false,
      speed: 400,
      mode: 'carousel',
      prevButton: '#' + sectionId + ' .js-slider-sites-prev',
      nextButton: '#' + sectionId + ' .js-slider-sites-next',
      autoplayButtonOutput: false,
      mouseDrag: true,
      autoplay: false,
      controls: true,
      freezable: true,
      touch: true,
      preventScrollOnTouch: true,
      navPosition: 'bottom',
      rewind: true,
      lazyload: false,
      center: false,
      loop: false,
      controlsContainer: '#' + sectionId + ' .recommendations-slider-controls',
      responsive: {
        480: {
          items: 1
        },
        640: {
          items: 2
        },
        768: {
          items: 3
        }
      }
    });
  }
})();
